<template>
  <div id="app">
    <SignIn />
    <notifications
      group="toast"
      position="bottom center"
      classes="vue-notification is-size-6 mb-5"
      :max="1"
      width="350"
    />
    <main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </main>
  </div>
</template>

<script>
import SignIn from "./views/market/auth/SignIn";

export default {
  name: "app",
  components: {
    SignIn
  }
};
</script>

<style>
</style>
